import { useHandleException } from '~/composables/useHandleException'
import type { Maybe } from '~/types'

export const useTermlyIo = (options: { enabled: boolean, websiteUuid: Maybe<string> }) => {
  if (!options?.enabled) {
    return
  }

  if (!options?.websiteUuid) {
    useHandleException(new Error('TermlyIo integration: website UUID is missing'))

    return
  }

  useHead({
    script: [
      {
        src: `https://app.termly.io/resource-blocker/${options.websiteUuid}?autoBlock=on`,
        id: 'termlyIo',
        tagPosition: 'head',
      },
    ],
  })
}
